module.exports = __webpack_public_path__ + "static/social-media-image-72c65bec9639ca51caf33e08d76a9d6b.jpg";